module.exports = __webpack_public_path__ + "img/EBSoftware1.19d7b89b.png";